import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import staticQueryData from "../../../../../../public/static/d/771086832.json";
/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import { StaticQuery } from 'gatsby';
import { mergeProps } from '@arcblock/ux/lib/Util';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import filterPost from '../post_latest/filter';
import PostCard from '../post_card';
var translations = {
  en: {
    viewMore: 'View More'
  },
  zh: {
    viewMore: '继续阅读'
  }
};
export default function LatestPostList(props) {
  var newProps = mergeProps(props, LatestPostList, ['limit', 'pageSize']);
  var category = newProps.category,
      tag = newProps.tag,
      limit = newProps.limit,
      pageSize = newProps.pageSize;
  var locale = translations[newProps.locale] ? newProps.locale : 'en';
  var viewMore = newProps.viewMore || translations[locale].viewMore;
  return /*#__PURE__*/React.createElement(StaticQuery, {
    query: "771086832",
    render: function render(data) {
      var all = data.news.edges.map(function (x) {
        return x.node;
      });
      var posts = all.filter(function (x) {
        return filterPost({
          post: x,
          locale: locale,
          tag: tag,
          category: category
        });
      });
      var settings = {
        dots: false,
        speed: 500,
        className: 'slide-item',
        slidesToShow: pageSize,
        slidesToScroll: pageSize,
        responsive: [{
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      };
      var posts2Render = posts.slice(0, limit);
      return /*#__PURE__*/React.createElement(Div, null, /*#__PURE__*/React.createElement(Slider, settings, posts2Render.map(function (post) {
        return /*#__PURE__*/React.createElement(PostCard, {
          key: post.frontmatter.path,
          style: {
            width: 288
          },
          post: post,
          viewMore: viewMore
        });
      })));
    },
    data: staticQueryData
  });
}
LatestPostList.defaultProps = {
  locale: 'en',
  category: '',
  tag: '',
  limit: 8,
  pageSize: 4,
  viewMore: ''
};
var Div = styled.div.withConfig({
  displayName: "post_slide__Div",
  componentId: "sc-1sb9742-0"
})([".slide-item{width:100%;}.slick-prev,.slick-next{width:48px;height:48px;border-radius:24px;opacity:0.6;background:#bcbcbc;z-index:99;}.slick-prev:hover,.slick-next:hover{opacity:1;background:#bcbcbc;}.slick-prev:before,.slick-next:before{font-family:'Font Awesome 5 Pro';font-weight:300;font-size:32px;color:#4a4a4a;}.slick-prev{left:-54px;}.slick-prev:before{content:'\f060';}.slick-next{right:-54px;}.slick-next:before{content:'\f061';}@media (max-width:", "px){.slick-prev{left:-16px;}.slick-next{right:-16px;}}.post-card{margin-right:0;margin-left:16px;padding-right:16px;margin-top:0;outline:none;&:active{outline:none;}}"], function (props) {
  return props.theme.breakpoints.values.lg;
});